import React from "react";
import { Routes, Route } from "react-router-dom";

import SignIn from "./SignIn";
import MainPage from "./MainPage";
import NeoBot_Pizza from "./NeoBot_Pizza/NeoBot_Pizza";
import Neobot_truck from "./Truck/NeoBot_truck";
import NeoBot from "./NeoBot/NeoBot";

function App() {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/main" element={<MainPage />} />
      <Route path="/neobot_pizza" element={<NeoBot_Pizza />} />
      <Route path="/neobot_truck" element={<Neobot_truck />} />
      <Route path="/neobot" element={<NeoBot/>} />
    </Routes>
  );
}

export default App;
